import React from 'react';

const Radio = ({data, index, state, updateState}) => {
  return (<div className={`field radio`}>
    <legend>{data.label}</legend>
    <div className={`options ${data.class}`}>
      {data.options.map((option, i) => {
        const value = (option.value !== undefined)?option.value:option.label

        return (
          <span key={i}>
            <input 
            id={`field_${index}_option_${i}`} 
            type="radio" 
            name={`radio_${index}`} 
            value={value}
            checked={state === value}
            onChange={(e) => updateState(e)}
            className={data.class} />
            <label htmlFor={`field_${index}_option_${i}`} >{option.label}</label>
          </span>
        )
      })}
    </div>
  </div>)
}

export default Radio;